export const getWalletInfo = {
  GET_WALLET_INFO_REQUEST: "GET_WALLET_INFO_REQUEST",
  GET_WALLET_INFO_SUCCESS: "GET_WALLET_INFO_SUCCESS",
  GET_WALLET_INFO_ERROR: "GET_WALLET_INFO_ERROR",
};

export const addWalletBalance = {
  ADD_WALLET_BALANCE_REQUEST: "ADD_WALLET_BALANCE_REQUEST",
  ADD_WALLET_BALANCE_SUCCESS: "ADD_WALLET_BALANCE_SUCCESS",
  ADD_WALLET_BALANCE_ERROR: "ADD_WALLET_BALANCE_ERROR",
};

export const deductWalletBalance = {
  DEDUCT_WALLET_BALANCE_REQUEST: "DEDUCT_WALLET_BALANCE_REQUEST",
  DEDUCT_WALLET_BALANCE_SUCCESS: "DEDUCT_WALLET_BALANCE_SUCCESS",
  DEDUCT_WALLET_BALANCE_ERROR: "DEDUCT_WALLET_BALANCE_ERROR",
};

export const getAccountBillingDetails = {
  GET_ACCOUNT_BILLING_DETAILS_REQUEST : "GET_ACCOUNT_BILLING_DETAILS_REQUEST" ,
  GET_ACCOUNT_BILLING_DETAILS_SUCCESS : "GET_ACCOUNT_BILLING_DETAILS_SUCCESS" ,
  GET_ACCOUNT_BILLING_DETAILS_ERROR : "GET_ACCOUNT_BILLING_DETAILS_ERROR" ,
}
